<div ngbAccordion [closeOthers]="true">
  @for (item of items(); track item.id) {
    @if ($index > 0) {
      <hr />
    }
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button class="text-focus-ring" ngbAccordionButton>{{ item.titel }}</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <div class="wordpress-content" [innerHTML]="item.inhalt | safeHtml"></div>
        </div>
      </div>
    </div>
  }
</div>
